<template>
  <v-timeline-item
    :dot-color="getColor(report.report_category)"
    size="small"
    class="timeline-item"
  >
    <template #icon>
      <v-avatar size="24" :color="getColor(report.report_category)">
        <v-icon :color="'white'" size="16">
          {{ getCategoryIcon(report.report_category) }}
        </v-icon>
      </v-avatar>
    </template>
    <ReportCard
      :report="report"
      :hide-buttons="hideButtons"
      :on-report-updated="onReportUpdated"
    />
  </v-timeline-item>
</template>

<script>
import { defineComponent } from "vue";
import { useReportCategoryIcons } from "@/composables/useReportCategoryIcons";
import ReportCard from "./ReportCard.vue";

export default defineComponent({
  name: "ReportTimeLineItem",
  components: {
    ReportCard,
  },
  props: {
    report: {
      type: Object,
      required: true,
    },
    onReportUpdated: {
      type: Function,
      default: null,
    },
    hideButtons: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    const { getCategoryIcon, getCategoryColor } = useReportCategoryIcons();

    const getColor = (category) => {
      return getCategoryColor(category);
    };

    return {
      getColor,
      getCategoryIcon,
    };
  },
});
</script>

<style scoped>
/* Timeline item specific styles - card styles are now in ReportCard.vue */
</style>
